import React,{useRef,useEffect} from 'react';
import TIMEOUT from '../assets/img/clock.png';
const OfferModal = ({ offer, onClose,content,mode, background }) => {
  const OutsideClickRef = useRef(null);
  
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });

  const handleOutsideClick = (e) => {
    if (OutsideClickRef.current && !OutsideClickRef.current.contains(e.target)) {
      onClose(false);
    }
  };

  return (
    <div className="modal">
      <div className={mode === 'tiny'?'tiny-modal-content':'modal-content'} ref={OutsideClickRef} >
        {background && <img src={TIMEOUT} alt='Rrefresh' className='timeout'/>}
        <button type="button" onClick={() => onClose(false)} className="blank-button"><span className="iconify close-modal" data-icon="iconamoon:close-bold"></span></button>
        {content}
      </div>
    </div>);
};

export default OfferModal;